/**
 * Static demo tree for Your Path to Readiness (same row shape as API transforms).
 * Toggle via useStaticPathToReadinessData in AsEmployeeTab.vue.
 */
export function getStaticPathToReadinessSample() {
  const rows = [
    {
      id: "position_demo_1",
      parentId: -1,
      assignment_id: 9001,
      data: {
        type: "position",
        commitmentLevel: "Primary",
        assignmentType: "position",
        importanceLevel: 2,
        importanceSelector: true,
        totalSteps: 3,
        code: "#1001",
        name: "Operations Lead",
        isNew: false,
        isAccepted: true,
        acceptanceStatus: "accepted",
        hasRoles: true,
        roleCount: 1,
        commitment: "Primary",
      },
      status: "active",
      readiness: 72,
    },
    {
      id: "role_demo_1",
      parentId: "position_demo_1",
      assignment_id: 9002,
      data: {
        type: "role",
        commitmentLevel: "Primary",
        assignmentType: "role",
        importanceLevel: 2,
        importanceSelector: true,
        totalSteps: 3,
        code: "#2001",
        name: "Safety Coordinator",
        isNew: false,
        isAccepted: true,
        acceptanceStatus: "accepted",
        hasResponsibilities: true,
        responsibilityCount: 3,
        commitment: "Primary",
      },
      status: "active",
      readiness: 65,
    },
    {
      id: "responsibility_demo_1",
      parentId: "role_demo_1",
      assignment_id: 9003,
      data: {
        type: "responsibility",
        commitmentLevel: "Primary",
        assignmentType: "responsibility",
        importanceLevel: 3,
        importanceSelector: true,
        totalSteps: 3,
        code: "#3001",
        name: "Conduct daily safety briefings",
        isNew: true,
        isAccepted: false,
        acceptanceStatus: "pending",
        responsibility_id: 3001,
        badge: {
          id: 1,
          level: 1,
          status: "given",
          expiration_date: null,
          issued_method: "given",
        },
        checkpointCounts: {
          apprentice_checkpoint_count: 4,
          professional_checkpoint_count: 2,
          coach_checkpoint_count: 0,
          master_checkpoint_count: 0,
          apprentice_passed_checkpoint_count: 2,
          professional_passed_checkpoint_count: 1,
          coach_passed_checkpoint_count: 0,
          master_passed_checkpoint_count: 0,
        },
        avatars: [
          {
            id: 1,
            badgeLevel: "Professional",
            firstName: "Alex",
            lastName: "Rivera",
            fullName: "Alex Rivera",
            title: null,
            img: "",
            isHoverEnabled: false,
          },
          {
            id: 2,
            badgeLevel: "Coach",
            firstName: "Sam",
            lastName: "Lee",
            fullName: "Sam Lee",
            title: null,
            img: "",
            isHoverEnabled: false,
          },
        ],
      },
      checkpointsData: [
        {
          proficiency_level: 1,
          evaluation_status: "passed",
          status: "active",
        },
        {
          proficiency_level: 2,
          evaluation_status: "pending",
          status: "active",
        },
      ],
      status: "active",
      readiness: 45,
    },
    {
      id: "responsibility_demo_2",
      parentId: "role_demo_1",
      assignment_id: 9004,
      data: {
        type: "responsibility",
        commitmentLevel: "Primary",
        assignmentType: "responsibility",
        importanceLevel: 2,
        importanceSelector: true,
        totalSteps: 3,
        code: "#3002",
        name: "Maintain incident log",
        isNew: false,
        isAccepted: true,
        acceptanceStatus: "accepted",
        responsibility_id: 3002,
        badge: {
          id: 2,
          level: 2,
          status: "good_standing",
          expiration_date: null,
          issued_method: "good_standing",
        },
        checkpointCounts: {
          apprentice_checkpoint_count: 3,
          professional_checkpoint_count: 3,
          coach_checkpoint_count: 2,
          master_checkpoint_count: 0,
          apprentice_passed_checkpoint_count: 3,
          professional_passed_checkpoint_count: 2,
          coach_passed_checkpoint_count: 1,
          master_passed_checkpoint_count: 0,
        },
        avatars: [
          {
            id: 3,
            badgeLevel: "Master",
            firstName: "Jordan",
            lastName: "Kim",
            fullName: "Jordan Kim",
            title: null,
            img: "",
            isHoverEnabled: false,
          },
        ],
      },
      checkpointsData: [
        {
          proficiency_level: 1,
          evaluation_status: "passed",
          status: "active",
        },
        {
          proficiency_level: 2,
          evaluation_status: "passed",
          status: "active",
        },
      ],
      status: "active",
      readiness: 88,
    },
    {
      id: "responsibility_demo_3",
      parentId: "role_demo_1",
      assignment_id: 9005,
      data: {
        type: "responsibility",
        commitmentLevel: "Primary",
        assignmentType: "responsibility",
        importanceLevel: 1,
        importanceSelector: true,
        totalSteps: 3,
        code: "#3003",
        name: "Complete quarterly audit checklist",
        isNew: false,
        isAccepted: true,
        acceptanceStatus: "accepted",
        responsibility_id: 3003,
        badge: null,
        checkpointCounts: {
          apprentice_checkpoint_count: 5,
          professional_checkpoint_count: 0,
          coach_checkpoint_count: 0,
          master_checkpoint_count: 0,
          apprentice_passed_checkpoint_count: 0,
          professional_passed_checkpoint_count: 0,
          coach_passed_checkpoint_count: 0,
          master_passed_checkpoint_count: 0,
        },
        avatars: [],
      },
      checkpointsData: [],
      status: "active",
      readiness: 12,
    },
  ];

  return {
    dataSource: rows,
    expandedKeys: ["position_demo_1", "role_demo_1"],
    paginationTotal: rows.filter((r) => r.parentId === -1).length,
  };
}
